import * as React from 'react';

import { type UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { generalMessages } from 'src/utils/messages';

import type { AllowListMemberFormSchemaValues } from 'src/features/parkingManagement/api/AllowListAPI/useCreateAllowListMember';

type AllowListMemberFormProps = {
    form: UseFormReturn<AllowListMemberFormSchemaValues>;
    onSubmit: (values: AllowListMemberFormSchemaValues) => void;
};

export default function AllowListMemberForm({ onSubmit, form }: AllowListMemberFormProps) {
    const { formatMessage } = useIntl();

    const email = form.watch('email');

    React.useEffect(() => {
        if (email === '') form.setValue('email', null);
    });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<AllowListMemberFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(generalMessages.name)}
            />
            <InputFormField<AllowListMemberFormSchemaValues>
                form={form}
                name="identifier"
                label={formatMessage(allowListMessages.identifier)}
            />
            <InputFormField<AllowListMemberFormSchemaValues>
                required={false}
                form={form}
                name="email"
                label={formatMessage(allowListMessages.email)}
                transform={(value) => value.toLowerCase()}
            />
            <InputFormField<AllowListMemberFormSchemaValues>
                required={false}
                form={form}
                name="group_name"
                label={formatMessage(allowListMessages.groupName)}
            />
        </Form>
    );
}
